import Tile from "./Tile"

import {IconDownload} from "@amzn/stencil-react-components/icons"
import {Col, Row, Spacer} from "@amzn/stencil-react-components/layout"
import {Text} from "@amzn/stencil-react-components/text"

class DownloadTile extends Tile {

  constructor(props) {
    super(props)
  }

  renderInfo(info) {
    return (
      <Row dataTestId="download_Info" alignItems="center">
        <IconDownload
          color="primary70"
          aria-hidden={true}
        />
        <Spacer width={20}/>
        <Text fontWeight="bold" fontSize="T300" textAlign='left'>{info}</Text>
      </Row>
    )
  }

  renderFooter(footer) {
    if (this.props.loading) {
      return null;
    }

    return (
      <Row dataTestId="download_Footer" padding={{left:35}}>
        <Text color="primary70" textAlign='left'>{footer}</Text>
      </Row>
    )
  }

  renderCardContent() {
    return (
      <Col dataTestId="download_CardContent" width="100%" gridGap="S200">
        {this.renderInfo(this.props.info)}
        {this.renderFooter(this.props.footer)}
      </Col>
    )
  }

  render() {
    return super.renderTile(this.props.isClickable);
  }
}

export default DownloadTile
